import React, {Component} from 'react';
import FontAwesome from 'react-fontawesome'
import {connect} from 'react-redux'
import EN from 'asset/img/icons/en.png'
import TH from 'asset/img/icons/th.png'
import onClickOutside from 'react-onclickoutside'
import AuthenStore from 'stores/AuthenStore'
import './LangMenu.css'
let actions = require('actions');
class LangMenu extends Component {
    constructor(...args){
        super(...args);

        this.state = {open:false}
    }

    onToggleClick(){
        this.setState({open:!this.state.open})
    }

    setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
      }
    
      handleClickOutside = evt => {
        this.setState({
          open: false
        })
        console.log('click outsite');
      }

    onLangChange(lang){
        this.setCookie('bf_locale',lang,99999);
        this.props.switchLanguage(lang)    
        //Refresh
        AuthenStore.switchLanguage(lang,()=>{
            window.location.reload(true)    
        })
        
    }

    renderFlag(){
        let {lang} = this.props
        if(lang=='th') 
            return (
                <img width='30px' alt='' src={TH} />
            )
        else if(lang=='en')
            return (
                <img width='30px' alt='' src={EN} />
            )
        else{
            return (<FontAwesome name='flag-o'/>)
        }
    }

    render(){
        let {open} = this.state
        let {messages} = this.props
        return (
            <ul className="lang-menu nav navbar-nav">
                <li className={"dropdown tasks-menu "+(open?"open":"")} onClick={this.onToggleClick.bind(this)}>
                    <a href="#" className="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">              
                    {this.renderFlag()}
                    </a>
                    <ul className="dropdown-menu">
                    <li className="header">{messages['Select']}</li>              
                    <li className="footer">
                        <a href="#" onClick={this.onLangChange.bind(this,'th')}><img width='30px' alt='' src={TH} /> {messages['Thai']}</a>
                        <a href="#" onClick={this.onLangChange.bind(this,'en')}><img width='30px' alt='' src={EN} /> {messages['English']}</a>
                    </li>
                    </ul>
                </li>
            </ul>
        )
    }
}

LangMenu = onClickOutside(LangMenu);

export default LangMenu = connect(
    (state) => ({messages: state.message.view.menu.LangMenu,lang:state.locale}),
    (dispatch) => ({switchLanguage: (lang) => dispatch(actions.switchLanguage(lang))}),null,{forwardRef:true}
)(LangMenu);




// WEBPACK FOOTER //
// ./src/view/menu/LangMenu.js